import {
  CURRENT_PAGE,
  INIT_PENCIL_CASE,
  FLIPBOOK_ZOOM_IN,
  FLIPBOOK_ZOOM_OUT,
} from 'actions/FlipbookActions'

function initialState() {
  return {
    currentPage: 0,
    pencilCase: 0,
    zoom: false,
  }
}

export default function flipbook(state = initialState(), action) {
  switch (action.type) {
    case CURRENT_PAGE:
      return state ? { ...state, currentPage: action.payload } : { currentPage: action.payload }
    case INIT_PENCIL_CASE:
      return state ? { ...state, pencilCase: action.payload } : { pencilCase: action.payload }
    case FLIPBOOK_ZOOM_IN:
      return { ...state, ...action.payload }
    case FLIPBOOK_ZOOM_OUT:
      return { ...state, ...action.payload }
    default:
      return state
  }
}
